module.exports = __webpack_public_path__ + "img/secretary.96ea50a1.png";